export const validatePasswordsMatch = (formValues, t) => {
  const errors = {};
  if (formValues.password !== formValues.confirm) {
    errors.confirm = t("New_Password_And_Confirm_Password_Do_Not_Match");
  }
  return errors;
};
